import React, { useEffect, useState } from "react";
import "./Components.css";
import CustomDropdown from "../../Products/AddProduct/Components/CustomDropdown/CustomDropdown";
import { removeUnderscoresAndCapitalize } from "../../../helpers/helpers";
import { fetchOrderStatuses } from "../../../services/orders.services";
import { useTranslation } from "react-i18next";
const PaymentDetails = ({ data, setData, editMode, setEditMode }) => {
  const { t } = useTranslation("sales");
  const [orderStatuses, setOrderStatuses] = useState();
  const handleFieldChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };
  const getOrderStatuses = async () => {
    try {
      const response = await fetchOrderStatuses();
      if (response.error) {
        console.log(response.error);
      } else {
        setOrderStatuses(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getOrderStatuses();
  }, []);
  const handleShippingTotal = (value) => {
    setData({
      ...data,
      shipping_total: value,
    });
  };
  function capitalizeFirstLetter(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1) ?? "";
  }
  return (
    <div className="sss__payment_section">
      <div className="sss__pmtsection_heading">{t("orderDetails")}</div>
      <div
        className="sss__addressection_inputrow"
        style={{ justifyContent: "space-between", alignItems: "flex-end" }}
      >
        <div className="sss__addressection_inputcol">
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">{t("orderType")}</label>
            <CustomDropdown
              optionObjects={[
                "Walkin",
                "Manual",
                "MarketPlace",
                "Self Delivery",
                "Self Pickup",
                "Return",
              ].map((value) => ({
                title: t(`orderTypes.${value}`, { defaultValue: value }),
                value,
              }))}
              onSelect={(option) => {
                setData({ ...data, type: option.value });
              }}
              selectedLabel={
                data.type
                  ? t(`orderTypes.${data.type}`, { defaultValue: data.type })
                  : data.type
              }
            />
          </div>
        </div>
        {data?.type === "Self Pickup" && (
          <div className="sss__addressection_inputcol">
            <div className="sss__addressection_inputbox">
              <label className="sss__addressection_inputtitle">
                {t("pickupDate")}
              </label>
              <input
                className="sss__addressection_inputfield"
                type="date"
                onChange={(e) =>
                  setData({ ...data, pickup_date: e.target.value })
                }
                value={data.pickup_date}
              />
            </div>
          </div>
        )}
      </div>
      <div className="sss__addressection_inputrow">
        <div
          className="sss__addressection_inputcol"
          style={{ minWidth: "200px" }}
        >
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">
              {t("orderStatus")}
            </label>
            <CustomDropdown
              optionObjects={["Pending", "Confirmed", "On Hold", "Cancelled"].map(
                (value) => ({
                  title: t(`orderStatuses.${value}`, { defaultValue: value }),
                  value,
                }),
              )}
              onSelect={(option) => {
                setData({ ...data, status: option.value });
              }}
              disabled={
                (editMode && data?.fullfilment_status?.id == 4) ||
                data.status == "Cancelled"
              }
              selectedLabel={
                data.status
                  ? t(`orderStatuses.${data.status}`, { defaultValue: data.status })
                  : data.status
              }
            />
          </div>
        </div>
        <div className={"sss__addressection_inputbox"}>
          <label className="sss__addressection_inputtitle">
            {t("fulfilmentStatus")}
          </label>
          {data?.fullfilment_status?.name?.toLowerCase() === "attention" ? (
            <CustomDropdown
              optionObjects={orderStatuses
                ?.filter((status) =>
                  ["attention", "attended"].includes(
                    status?.name?.toLowerCase()
                  )
                )
                ?.map((status) => {
                  return { title: status.name, value: status.id };
                })}
              onSelect={(option) => {
                setData({ ...data, order_status_id: option.value });
              }}
              selectedLabel={
                orderStatuses?.find((item) => item.id === data.order_status_id)
                  ?.name
              }
            />
          ) : (
            <input
              className="sss__addressection_inputfield"
              type="text"
              value={
                capitalizeFirstLetter(data?.fullfilment_status?.name) || ""
              }
              style={{ color: "#A1A8B4" }}
              disabled
            />
            // <input
            //   className="sss__addressection_inputfield sss__addressection_inputfielddisabled"
            //   type="text"
            //   // placeholder="Enter Total Amount"
            //   value={data?.fullfilment_status?.name?.toUpperCase()}
            // />
          )}

          {/* {Object.keys(errors)?.includes("width") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.width?.msg}
              </div>
            )} */}
        </div>
      </div>{" "}
      <div
        style={{ borderBottom: "1px solid var(--color-ui-border)", padding: "5px 0px" }}
      ></div>
      <div className="sss__pmtsection_labelbold">{t("payment")}</div>
      <div className="sss__addressection_inputrow">
        <div
          className="sss__addressection_inputcol"
          style={{ minWidth: "200px" }}
        >
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">
              {t("amountReceived")}
            </label>
            <input
              className="sss__addressection_inputfield"
              type="text"
              placeholder={t("enterRecievedAmount")}
              onChange={(e) =>
                handleFieldChange("amount_received", e.target.value)
              }
              value={data.amount_received}
            />
            {/* <div className="sss__addressection_inputfielderror">
              <MdErrorOutline className="sss__addressection_inputfielderroricn" />
              Supplier Name is required
            </div> */}
          </div>
        </div>
        {(data?.payment_method_title === "Cash On Pickup" ||
          data?.payment_method_title === "Cash On Delivery") && (
          <>
            <div
              className="sss__addressection_inputcol"
              style={{ minWidth: "120px" }}
            >
              <div className="sss__addressection_inputbox">
                <label className="sss__addressection_inputtitle">
                  {t("amountPending")}
                </label>
                <input
                  className="sss__addressection_inputfield"
                  type="text"
                  placeholder={t("enterAmountReceiveableByWarehouse")}
                  onChange={(e) =>
                    handleFieldChange("amount_pending", e.target.value)
                  }
                  value={data.amount_pending}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="sss__addressection_inputrow">
        <div
          className="sss__addressection_inputcol"
          style={{ minWidth: "200px" }}
        >
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">
              {t("paymentMethod")}
            </label>
            <CustomDropdown
              optionObjects={[
                "Direct Bank Transfer",
                "Debit or Credit Card",
                "E-Transfer",
                "Cash On Delivery",
                "Cash On Pickup",
              ].map((value) => ({
                title: t(`paymentMethods.${value}`, { defaultValue: value }),
                value,
              }))}
              onSelect={(option) => {
                setData({ ...data, payment_method_title: option.value });
              }}
              selectedLabel={
                data.payment_method_title
                  ? t(`paymentMethods.${data.payment_method_title}`, {
                      defaultValue: data.payment_method_title,
                    })
                  : data.payment_method_title
              }
            />
          </div>
        </div>
        {editMode &&
          (data?.payment_method_title === "Cash On Pickup" ||
            data?.payment_method_title === "Cash On Delivery") && (
            <>
              <div
                className="sss__addressection_inputcol"
                style={{ minWidth: "200px" }}
              >
                <div className="sss__addressection_inputbox">
                  <label className="sss__addressection_inputtitle">
                    {t("amountReceivedByWarehouse")}
                  </label>
                  <input
                    className="sss__addressection_inputfield "
                    type="text"
                    placeholder={t("amountReceivedByWarehouse")}
                    // onChange={(e) =>
                    //   handleFieldChange(
                    //     "warehouse_amount_recieved",
                    //     e.target.value
                    //   )
                    // }
                    disabled
                    value={data?.amount_received_by_warehouse}
                  />
                  {/* <div className="sss__addressection_inputfielderror">
              <MdErrorOutline className="sss__addressection_inputfielderroricn" />
              Supplier Name is required
            </div> */}
                </div>
              </div>{" "}
            </>
          )}
      </div>
      <div
        className="sss__addressection_inputrow"
        style={{ margin: "5px 0px" }}
      >
        <div
          className="sss__addressection_inputcol"
          style={{ minWidth: "200px" }}
        >
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">
              {t("totalAmount")}
            </label>
            <input
              className="sss__addressection_inputfield sss__addressection_inputfielddisabled"
              type="text"
              placeholder={t("enterTotalAmount")}
              value={data.formula?.salePrice}
            />
          </div>
        </div>
        {/* <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          
        </div> */}
        {/*  )} */}
        <div
          className="sss__addressection_inputcol"
          style={{ minWidth: "120px" }}
        >
          <div className="sss__addressection_inputbox">
            <label className="sss__addressection_inputtitle">
              {t("shippingTotal")}
            </label>
            <input
              className="sss__addressection_inputfield"
              type="text"
              placeholder={t("enterShippingTotal")}
              value={data?.shipping_total}
              onChange={(e) => handleShippingTotal(e.target.value)}
            />
            {/* <div className="sss__addressection_inputfielderror">
              <MdErrorOutline className="sss__addressection_inputfielderroricn" />
              Supplier Cost is required
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
